import { adminAxios } from "../axiosInstance";
import { notify } from "../components/toastify";

// let hasNotified = false;
export const fetchData = async (
  endpoint,
  page = 1,
  search = "",
  formData = {},
) => {
  try {
    let url = `${endpoint}?page=${page}`;
    if (search) {
      url += `&searchParam=${search}`; // Correctly append search parameter
    }

    const response = await adminAxios.post(url, formData);
    // console.log(response);
    // notify("successful");
    return response.data;
  } catch (error) {
    // if (!hasNotified) {
    notify(error.response.data.message || error.message);
    // throw new Error("Error fetching data" + error.message);
  }
};

export const fetchOnlyData = async (endpoint) => {
  try {
    let url = `${endpoint}`;

    const response = await adminAxios.get(url, {});

    return response?.data?.data;
  } catch (error) {
    // if (!hasNotified) {
    notify(error?.response?.data?.message || error.message);
    return error;
    // throw new Error("Error fetching data" + error.message);
  }
};

export const createData = async (endpoint, data, showNotification) => {
  try {
    const response = await adminAxios.post(`${endpoint}`, data);
    // console.log(response.data.message);
    if (showNotification) {
    } else {
      notify(response.data.message, "success");
    }
    return response.data; // Adjust based on the structure of your response
  } catch (error) {
    notify(error.response.data.message || error.message);
    return error;
  }
};

export const updateData = async (endpoint, id, data) => {
  try {
    const response = await adminAxios.put(`${endpoint}${id}`, data);
    notify(response?.data?.message, "success");
    return response?.data;
    // Adjust based on the structure of your response
  } catch (error) {
    notify(error?.response?.data?.message || error.message);
    return error;
  }
};

export const deleteData = async (endpoint, id) => {
  try {
    const response = await adminAxios.delete(`${endpoint}${id}`);
    notify(response.data.message, "success");
    return response?.data; // Adjust based on the structure of your response
  } catch (error) {
    notify(error.response.data.message || error.message);
  }
};

export const getDataById = async (endpoint, id) => {
  try {
    const response = await adminAxios.get(`${endpoint}${id}`);

    return response; // Adjust based on the structure of your response
  } catch (error) {
    notify(error.response.data.message || error.message);
  }
};
